import React, {Component} from 'react';
import { connect } from 'react-redux';

import Loading from 'components/Loading';
import HeaderNotification from 'components/notification/HeaderNotification';
import ItemSettingCheckBlockList from 'components/notification/ItemSettingCheckBlockList';
import LoginRedirect from 'components/LoginRedirect'
import {dt} from 'l10n';

import '../../sass/notificationSetting.scss';

import { getMemberNotificationSettings, setMemberNotificationSettings } from 'reducers/memberNotificationSetting';

class memberNotificationSetting extends Component {
    constructor(props) {
        super(props);
        this.state = { loginRedirect: false, message: '' };
    }

    componentDidMount() {
        const { dispatch, location: { hash }} = this.props;
        
        const action = hash ? getMemberNotificationSettings({ hash }) : getMemberNotificationSettings();
        dispatch(action);

        action.promise
            .then(data => {
                if (data.data.status === "error") {
                    this.setState({ loginRedirect: true })
                }
            })
            .catch(e => {
                console.log(e)
            })
    }

    saveSettings = reducerParams => {
        const { dispatch, location: { hash }} = this.props;
        const action = hash ? setMemberNotificationSettings({ ...reducerParams, hash }) : setMemberNotificationSettings(reducerParams);
        dispatch(action);

        action.promise
          .then(data => {
              this.setState({ message: data.data.message })
          })
          .catch(e => {
              console.log(e)
          });

        return action;
    };

    render() {
        if (this.state.loginRedirect) return <LoginRedirect location={this.props.location}/>;

        if (!this.props.memberNotificationSetting || !this.props.memberNotificationSetting.settings) return <Loading centered/>;

        const { 
            email,
            settings
        } = this.props.memberNotificationSetting;

        const { message } = this.state;

        return (
            <div id="wrapper">
                <HeaderNotification title={dt('notifications','Notifications settings')}/>

                <aside className="notification-setting">
                    <div className="content">
                        <ItemSettingCheckBlockList email={email} settings={settings} saveSettings={this.saveSettings} message={message}/>
                    </div>
                </aside>
            </div>
        )
    }
}

export default connect(
    state => ({
        memberNotificationSetting: state.memberNotificationSetting
    }),
    null
)(memberNotificationSetting)


// WEBPACK FOOTER //
// ./src/containers/member/MemberNotificationSetting.js